import { Navigate, useLocation, useParams } from 'react-router-dom';

/** The previous site's /product/<slug> addresses open the product page. */
const ProductRedirect = () => {
  const { slug } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/products/${encodeURIComponent(slug)}${search}`} replace />;
};

export default ProductRedirect;
